import { render, staticRenderFns } from "./assetsClassification.vue?vue&type=template&id=d8bd813a&scoped=true&"
import script from "./assetsClassification.vue?vue&type=script&lang=js&"
export * from "./assetsClassification.vue?vue&type=script&lang=js&"
import style0 from "./assetsClassification.vue?vue&type=style&index=0&id=d8bd813a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8bd813a",
  null
  
)

export default component.exports